import { AxiosResponse } from "axios";

import API from "../api";

import { Financials } from "../models/financials";

const ROUTE_NAME = "financials";

const FinancialsService = {
  async get(companyId: number, options?: any): Promise<AxiosResponse<Financials>> {
    return await API.get(`/${ROUTE_NAME}/${companyId}`, { params: options });
  },
  async update(companyId: number, record: Financials): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${companyId}`, record);
  },
};

export default FinancialsService;
